import { combineReducers } from 'redux'

import reducers from './reducers'

export const reducer = combineReducers({
  analytics: reducers,
})

export default reducer
